import React, { useEffect, useRef } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ArchitectsOfYourFinancialFuture() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll();
  const imageContainerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!imageContainerRef.current) return;
      const img = imageContainerRef.current.querySelector("img");
      if (img) {
        const speed = 0.08;
        const yPos = window.scrollY * speed;
        img.style.transform = `translateY(${yPos}px)`;
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="25948" id="maximize-your-practice-revenue" className="relative w-full min-h-[90vh] flex items-center bg-background text-foreground overflow-hidden py-20 lg:py-0 dark">
      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634544/img/noise_texture.png')] mix-blend-overlay"></div>

      <div className="container mx-auto px-6 md:px-12 h-full relative z-10">
        <div className="flex flex-col lg:flex-row items-center h-full gap-16 lg:gap-24">
          
          {}
          <div ref={contentRef} className={`w-full lg:w-3/5 flex flex-col justify-center space-y-10 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="space-y-6">
              <span className="inline-block font-sans text-lg md:text-xl text-primary tracking-wide border-b border-primary/20 pb-2">
                Precision Medical RCM
              </span>
              
              <h1 className="text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-default font-bold tracking-tighter leading-[1.05]">
                <span className="bg-gradient-to-br from-white via-blue-200 to-primary bg-clip-text text-transparent">
                  Maximize Your Practice <br className="hidden lg:block" />
                  Revenue
                </span>
              </h1>
              
              <p className="text-lg md:text-xl text-muted-foreground max-w-2xl font-sans font-medium leading-relaxed">
                Ferio Solutions delivers end-to-end medical billing, coding, and administrative services to optimize cash flow and operational efficiency for healthcare providers.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-5 pt-2">
              <Button asChild size="lg" className="bg-gradient-to-r from-chart-2 to-chart-4 text-white hover:opacity-90 border-none rounded-sm px-10 h-14 text-base font-medium tracking-wide shadow-xl transition-transform hover:-translate-y-0.5">
                <Link to="#">
                  Start Consultation
                </Link>
              </Button>
              
              <Button asChild variant="ghost" size="lg" className="text-foreground hover:text-primary hover:bg-primary/10 rounded-sm px-8 h-14 text-base font-medium group relative overflow-hidden">
                <Link to="#">
                  <span className="relative z-10">Our Solutions</span>
                  <span className="absolute bottom-3 left-8 right-8 h-px bg-primary transform scale-x-0 origin-left transition-transform duration-300 group-hover:scale-x-100"></span>
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="w-full lg:w-2/5 h-[500px] lg:h-[750px] relative flex items-center justify-center lg:justify-end">
             <div ref={imageContainerRef} className="relative w-full max-w-md lg:max-w-full h-full overflow-hidden rounded-sm shadow-2xl border border-border bg-card">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634544/img/medical_facility_modern.png" alt="Modern medical facility with digital revenue growth overlay" className="absolute inset-0 w-full h-[120%] object-cover object-center will-change-transform" style={{
              top: '-10%'
            }} />
                
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent pointer-events-none"></div>
             </div>
          </div>

        </div>
      </div>
    </section>;
}